export const formatCountdownTime = (time) => {
  const { days = 0, hours = 0, minutes = 0, seconds = 0 } = time
  return `${days}d ${hours}h ${String(minutes).padStart(2, '0')}m ${String(
    seconds
  ).padStart(2, '0')}s`
}
